export default __webpack_public_path__ + "static/media/waldo_logo.cc7b9a88.png";